import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

// core components
import componentStyles from "assets/theme/components/cards/dashboard/card-dashboard-generic.js";
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import { useTheme } from "@material-ui/core/styles";
import { getUserRecentApplicationsDashboardAction } from "redux/actions/dashboardAction";
import TableStateChip from "components/Cards/Tables/TableStateChip";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import { TABLE_STATE_CHIP_COLOR, APPLICATION_STATES_APPROVED, APPLICATION_STATES_CANCELED, APPLICATION_STATES_IN_PROGRESS } from "utils/const";

const useStyles = makeStyles(componentStyles);
const useStylesGeneric = makeStyles(componentStylesGeneric);

const tableHead = ["Programa do Governo", "Programa", "Subprograma", "Nº Candidatura", "Estado", ""];

function CardMyGovernmentProgramsApplications(props) {
  const classes = { ...useStylesGeneric(), ...useStyles() };
  const theme = useTheme();

  useEffect(() => {
    props.getUserRecentApplicationsDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mapRecentApplicationsDashboardChipColors = (stateKey) => {
    if (APPLICATION_STATES_APPROVED.includes(stateKey)) {
      return TABLE_STATE_CHIP_COLOR.GREEN;
    }
    if (APPLICATION_STATES_CANCELED.includes(stateKey)) {
      return TABLE_STATE_CHIP_COLOR.RED;
    }
    if (APPLICATION_STATES_IN_PROGRESS.includes(stateKey)) {
      return TABLE_STATE_CHIP_COLOR.LIGHT_ORANGE;
    }
  };

  return (
    <CardTableContainer
      title={"Candidaturas em Curso a Apoios"}
      count={props.dashboardState?.getUserRecentApplicationsDashboard_result?.totalApplicationsCount
        ? props.dashboardState?.getUserRecentApplicationsDashboard_result?.totalApplicationsCount
        : 0}
      viewMoreLink={"/admin/my-applications/government-program-application"}
    >

      {props?.dashboardState?.getUserRecentApplicationsDashboard_result?.applicationsDashboardCard !== undefined &&
        props?.dashboardState?.getUserRecentApplicationsDashboard_result?.applicationsDashboardCard?.length > 0 && (
          <TableContainer>
            <Box
              component={Table}
              alignItems="center"
              marginBottom="0!important"
            >
              <TableHead>
                <TableRow>
                  {tableHead.map((prop, key) => (
                    <TableCell
                      key={key}
                      classes={{
                        root:
                          classes.tableCellRoot +
                          " " +
                          classes.tableCellRootHead,
                      }}
                    >
                      {prop}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.dashboardState?.getUserRecentApplicationsDashboard_result?.applicationsDashboardCard?.map((prop, key) => (
                  <TableRow key={key}>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      {prop.governmentProgramName}
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableRowEllipsis }} style={{ maxWidth: "140px" }}>
                      {prop.programName}
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableRowEllipsis }} style={{ maxWidth: "140px" }}>
                      {prop.subProgramName}
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableRowEllipsis }} style={{ maxWidth: "140px" }}>
                      {prop.applicationCode}
                    </TableCell>
                    <TableCell
                      classes={{
                        root: classes.tableCellRoot + " " + classes.actionsCell,
                      }}
                    >
                      <Box paddingTop=".35rem" paddingBottom=".35rem">
                        <TableStateChip
                          state={mapRecentApplicationsDashboardChipColors(prop.state?.key)}
                          message={prop.state?.description}
                        />
                      </Box>
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      <Tooltip title="Detalhes">
                        <IconButton
                          aria-label="details"
                          component={Link}
                          to={`/admin/application-details/${prop.applicationCode}`}
                        >
                          <Box
                            component={ArrowForwardIosIcon}
                            width="9px!important"
                            height="9px!important"
                            color={theme.palette.primary.main}
                          />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Box>
          </TableContainer>
        )}
    </CardTableContainer>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getUserRecentApplicationsDashboard: () => dispatch(getUserRecentApplicationsDashboardAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardMyGovernmentProgramsApplications);
